import { cn } from "@/lib/utils"
import { FOCUS_RING } from "./focusRing.constants"

export const BUTTON_VARIANT = {
    primary: "bg-ink text-surface hover:bg-ink/85",
    secondary: "bg-surface text-ink shadow-hairline-strong hover:bg-offwhite",
    outline: "bg-surface text-ink shadow-hairline-strong hover:bg-offwhite",
    ghost: "text-ink-2 hover:bg-ink/[0.05] hover:text-ink",
    control: "text-ink-2 hover:bg-ink/[0.08] hover:text-ink active:scale-100",
    destructive: "bg-tone-red-ink text-surface hover:bg-tone-red-ink/85",
    ghostDestructive: "text-tone-red-ink hover:bg-tone-red/50",
    onDark: "bg-white/[0.14] text-white hover:bg-white/[0.24]",
} as const

export const BUTTON_SIZE = {
    lg: "h-11 px-7 text-body",
    md: "h-10 px-5 text-body",
    sm: "h-8 px-3.5 text-callout",
    icon: "h-8 w-8",
    field: "h-9 rounded-field px-3 text-callout font-normal",
} as const

const BASE =
    "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full font-medium transition-colors " +
    `${FOCUS_RING} active:scale-[0.98] ` +
    "disabled:pointer-events-none disabled:bg-offwhite disabled:text-ink-3 disabled:shadow-none"

export function buttonClassName({
    variant = "primary",
    size = "md",
}: {
    variant?: keyof typeof BUTTON_VARIANT
    size?: keyof typeof BUTTON_SIZE
} = {}): string {
    return cn(BASE, BUTTON_VARIANT[variant], BUTTON_SIZE[size])
}
